import {
  ActionAudFilterDto,
  ActionAudPagedDto,
  Configuration,
  ControllerDedicatoAFunzioniSoloPerAuditApi,
  SearchActionAudRequest,
} from '@api/client';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum AuditActions {
  searchAuditActions = '[Audit] Search Audit Actions',
  saveAuditFiltersUsed = '[Audit] Save Audit Filters Used',
}

export const searchAuditActions = createAsyncThunk<ActionAudPagedDto | undefined, ActionAudFilterDto, ThunkApiConfig>(
  AuditActions.searchAuditActions,
  async (filters, { dispatch, extra, getState }) => {
    try {
      const payload: SearchActionAudRequest = {
        actionAudFilterDto: filters,
      };
      return await new ControllerDedicatoAFunzioniSoloPerAuditApi(
        getConfiguration(Configuration, extra, getState)
      ).searchActionAud(payload);
    } catch (e) {
      errorHandler(e, dispatch, getState);
    }
  }
);

export const saveAuditFiltersUsed = createAction<ActionAudFilterDto>(AuditActions.saveAuditFiltersUsed);
